import { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import BlogList from "../../components/BlogList/BlogList.js";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer.js";
import CtaSection from "../../components/ctaSection/ctaSection.js";
import Navbar2 from "../../components/Navbar2/Navbar2.js";
import img from "../../images/contact.jpg";

const BlogPage = () => {
  return (
    <Fragment>
      <Navbar2 hclass={"wpo-header-style-1"} />
      <PageTitle pageTitle={"Latest News"} pagesub={"Event"} img={img} />
      <BlogList />
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default BlogPage;
